var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 10.0001H16.267C15.9028 9.9993 15.5484 10.1178 15.2579 10.3376C14.9675 10.5573 14.757 10.8661 14.6587 11.2167L12.7003 18.1834C12.6877 18.2267 12.6614 18.2647 12.6253 18.2917C12.5893 18.3188 12.5454 18.3334 12.5003 18.3334C12.4552 18.3334 12.4114 18.3188 12.3753 18.2917C12.3393 18.2647 12.3129 18.2267 12.3003 18.1834L7.70033 1.81675C7.6877 1.77347 7.66139 1.73546 7.62533 1.70841C7.58926 1.68137 7.5454 1.66675 7.50033 1.66675C7.45525 1.66675 7.41139 1.68137 7.37533 1.70841C7.33926 1.73546 7.31295 1.77347 7.30033 1.81675L5.34199 8.78341C5.24405 9.13271 5.03481 9.44051 4.74605 9.66009C4.45728 9.87967 4.10476 9.99904 3.74199 10.0001H1.66699",
    stroke: "#0891B2",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/Health.d860a83793e9bd4253a96ec5923e2623.svg";
export { ForwardRef as ReactComponent };